import { render } from "./DialogValidFramesConfirmation.vue?vue&type=template&id=b4fb8e14&scoped=true"
import script from "./DialogValidFramesConfirmation.vue?vue&type=script&lang=js"
export * from "./DialogValidFramesConfirmation.vue?vue&type=script&lang=js"

import "./DialogValidFramesConfirmation.vue?vue&type=style&index=0&id=b4fb8e14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b4fb8e14"

export default script